export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FilesTab.vue?vue&type=template&id=06bf85f5&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/Lifting/FilesTab.vue?vue&type=template&id=06bf85f5&scoped=true
// module id = 1947
// module chunks = 31